var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("home1111111111 "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.open}},[_vm._v("打开摄像头")]),_c('video',{ref:"video",attrs:{"autoplay":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }